import React, {
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    createContext,
    useState,
} from 'react';
import statusInit from './statusInit';

type TStatus = 'unknown' | 'usable' | 'unusable';

interface ISessionStorageStatusValue {
    /**
     * If it is `unusable` and it is not an issue
     * of a private browser or an old browser, the
     *  issue may be that there is no more space available
     *  in SessionStorage.
     */
    status: TStatus;
    /**
     * **WARNING** Unless absolutely necessary, do
     *  not set the status of the SessionStorageStatusProvider.
     */
    setStatus: Dispatch<SetStateAction<TStatus>>;
}

const SessionStorageStatusContext = createContext<ISessionStorageStatusValue>({
    status: 'unknown',
    setStatus: () => {},
});

export default function SessionStorageStatusProvider({
    children,
}: PropsWithChildren<{}>) {
    const [status, setStatus] = useState<TStatus>(statusInit);

    return (
        <SessionStorageStatusContext.Provider value={{ status, setStatus }}>
            {children}
        </SessionStorageStatusContext.Provider>
    );
}

export function useSessionStorageStatus() {
    const context = React.useContext(SessionStorageStatusContext);
    if (context === undefined) {
        throw new Error(
            'useSessionStorageStatus must be used within a SessionStorageStatusProvider',
        );
    }
    return context;
}
